<template>
  <div class="routing-detail-track-trace">

    <h5 class="pt-5 title">Routing Details</h5>
    <b-card class="b-card-bg">
      <b-row
        class="justify-content-space-between card-text"
        :class="{ 'card-white': !isPublic }"
      >
        <b-col cols="12" md="6"
          ><span class="font-weight-bold">Quotation No.</span>
          <span class="hr">
            {{
              request_quotation.quotation
                ? request_quotation.quotation.toString().startsWith("WR1")
                  ? request_quotation.quotation
                  : ""
                : ""
            }}</span
          >
        </b-col>
        <b-col cols="12" md="6" class="text-end">
          <span class="font-weight-bold">Handling type</span>
          <span class="hr">{{ shipment_detail_view.shippingType }}</span></b-col
        >
        <b-col cols="12" class="mt-2"
          ><span class="font-weight-bold">Pick up address</span>
          <span class="hr">{{ shipment_detail_view.pickup_location }}</span>
        </b-col>
        <b-col cols="12" md="6" class="mt-2"
          ><span class="font-weight-bold">Pick up contact person</span>
          <span class="hr">{{ shipment_detail_view.pickUpContact.name }}</span>
        </b-col>
        <b-col cols="12" md="6" class="text-end mt-2">
          <span class="font-weight-bold">Pick up date</span>
          <span class="hr">{{ shipment_detail_view.pick_up_date }}</span></b-col
        >

        <b-col cols="12" class="mt-2"
          ><span class="font-weight-bold">Delivery address</span>
          <span class="hr">{{ shipment_detail_view.delivery_location }}</span>
        </b-col>

        <b-col cols="12" md="6" class="mt-2"
          ><span class="font-weight-bold">Delivery contact person</span>
          <span class="hr">{{
            shipment_detail_view.deliveryContact.name
          }}</span>
        </b-col>

        <b-col cols="12" md="6" class="text-end mt-2">
          <span class="font-weight-bold">Delivery date</span>
          <span class="hr">{{
            shipment_detail_view.inland_delivery_date
          }}</span></b-col
        >
        <b-col cols="12" class="mt-2"
          ><span class="font-weight-bold">Empty container depot</span>
          <span class="hr">{{ shipment_detail_view.deport }}</span>
        </b-col>

        <b-col cols="12" md="6" class="mt-2"
          ><span class="font-weight-bold">Container No.</span>
          <span class="hr">{{ shipment_detail_view.container_no }}</span>
        </b-col>

        <b-col cols="12" md="6" class="text-end mt-2">
          <span class="font-weight-bold">Seal No.</span>
          <span class="hr">{{ shipment_detail_view.seal }}</span></b-col
        >
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  props: {
    value: {
      type: Object,
      default: () => {
        return {};
      },
    },
    request_quotation: {
      type: Object,
      default: () => {
        return {};
      },
    },

    isPublic: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      shipment_detail_view: {
        quotation: "",
        shippingType: "",
        pickup_location: "",
        deliveryContact: {
          name: "",
        },
        pick_up_date: "",
        delivery_location: "",
        pickUpContact: {
          name: "",
        },
        deliveryContact: {
          name: "",
        },
        inland_delivery_date: "",
        deport: "",
        container_no: "",
        seal: "",
      },
    };
  },
  methods: {},
  computed: {
    ...mapState("masterData", [
      "service_types",
      "ports",
      "incoterms",
      "cont_types",
      "goods_types",
      "transport_types",
      "deports_locations",
      "deports",
      "business_types",
      "customs_types",
      "shipping_lines",
      "regions",
      "companyItems",
      "fee_types",
      "locations",
    ]),
  },
  watch: {
    value(n, old) {
      if (n) {
    
        this.shipment_detail_view.quotation = this.value?.quotation || "";
        this.shipment_detail_view.shippingType =
          this.transport_types.find((e) => e.id == this.value?.shippingType)
            ?.name || "";
        this.shipment_detail_view.pickup_location =
          this.locations.find((b) => b.id == this.value?.pickup_location)
            ?.name || "";

        this.shipment_detail_view.pick_up_date = this.value?.pick_up_date || "";
        this.shipment_detail_view.delivery_location =
          this.locations.find((b) => b.id == this.value?.delivery_location)
            ?.name || "";

        this.shipment_detail_view.pickUpContact.name =
          this.value?.pickUpContact?.name || "";
        this.shipment_detail_view.deliveryContact.name =
          this.value?.deliveryContact?.name +
          " " +
          this.value?.deliveryContact?.phone;

        this.shipment_detail_view.inland_delivery_date =
          this.value?.inland_delivery_date || "";
        this.shipment_detail_view.deport =
          this.locations.find((b) => b.id == this.value?.deport)
            ?.abbreviations || "";
        this.shipment_detail_view.container_no = this.value?.container_no || "";
        this.shipment_detail_view.seal = this.value?.seal || "";
      }
    },

  },

  mounted() {
   setTimeout(() => {
    if (this.value ) {
      this.shipment_detail_view.quotation = this.value?.quotation || "";
      this.shipment_detail_view.shippingType =
        this.transport_types.find((e) => e.id == this.value?.shippingType)
          ?.name || "";
      this.shipment_detail_view.pickup_location =
        this.locations.find((b) => b.id == this.value?.pickup_location)?.name ||
        "";

      this.shipment_detail_view.delivery_location =
        this.locations.find((b) => b.id == this.value?.delivery_location)
          ?.name || "";

      this.shipment_detail_view.pickUpContact.name =
        (this.value?.pickUpContact?.name || "") +
        " " +
        (this.value?.pickUpContact?.phone || "");

      this.shipment_detail_view.deliveryContact.name =
        (this.value?.deliveryContact?.name || "") +
        " " +
        (this.value?.deliveryContact?.phone || "");

      this.shipment_detail_view.deport =
        this.locations.find((b) => b.id == this.value?.deport)?.abbreviations ||
        "";
      this.shipment_detail_view.container_no = this.value?.container_no || "";
      this.shipment_detail_view.seal = this.value?.seal || "";

      this.shipment_detail_view.pick_up_date =
        (this.value?.pickUpDate || "") + " " + (this.value?.pickUpTime || "");

      this.shipment_detail_view.inland_delivery_date =
        (this.value?.deliveryDate || "") +
        " " +
        (this.value?.deliveryTime || "");
    }
   }, 2000);
  },
};
</script>

<style lang="scss">
.routing-detail-track-trace {
  .card-text {
    padding: 20px 10px;
    margin: 10px 0px;
  }
  .hr {
    border-left: 2px solid #fff;
    margin-left: 10px;
    padding-left: 10px;
  }
  .card-white {
    .hr {
      border-left: 2px solid #e1f1ee;
    }
  }
  .justify-content-space-evenly {
    justify-content: space-evenly;
  }
  .text-end {
    text-align: end;
  }
}
.card-green {
  background-color: #e2f2ef;
}
</style>
